import React from 'react';
import { motion } from 'framer-motion';
export function Agitation() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-lg p-6 md:p-12 border border-gray-100" data-id="element-27">
          <div className="prose prose-lg max-w-none" data-id="element-28">
            <p className="text-lg md:text-2xl text-gray-800 leading-relaxed mb-4 md:mb-6 font-medium" data-id="element-29">
              Bycie trenerem piłki nożnej w Polsce dzisiaj nie jest proste
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4" data-id="element-30">
              Co tydzień musisz tworzyć nowy plan treningowy od zera. Każda
              grupa wiekowa wymaga innego podejścia. Rodzice pytają o konkretne
              wyniki i postępy.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4" data-id="element-31">
              Pracujesz ciężko każdego dnia — ale nadal czujesz że brakuje Ci
              jasnego systemu.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6" data-id="element-32">
              To nie jest Twoja wina. Nikt nigdy nie dał Ci systemu który
              naprawdę działa.
            </p>

            {/* New pain-block: italic, light-gray background, red left-border */}
            <div className="my-8 p-5 md:p-7 rounded-lg border-l-4" style={{
            background: '#F4F6F8',
            borderLeftColor: '#EF4444'
          }} data-id="element-33">
              <p className="italic text-base md:text-lg leading-relaxed" style={{
              color: '#0F1F3D'
            }} data-id="element-34">
                Każda niedziela wieczór przy laptopie. Każdy poniedziałek z
                improwizowanym planem. Każdy trening gdzie czujesz że mogłeś być
                lepiej przygotowany. To się kończy dzisiaj.
              </p>
            </div>

            <p className="text-xl md:text-3xl font-display font-bold text-navy-primary text-center mt-8" data-id="element-35">
              Aż do dziś.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}